import { render, staticRenderFns } from "./BaseCamera.vue?vue&type=template&id=b499ecd4&scoped=true"
import script from "./BaseCamera.vue?vue&type=script&lang=js"
export * from "./BaseCamera.vue?vue&type=script&lang=js"
import style0 from "./BaseCamera.vue?vue&type=style&index=0&id=b499ecd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b499ecd4",
  null
  
)

export default component.exports